/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type TaskEvaluationConfigFormalCriteriaSource =
  (typeof TaskEvaluationConfigFormalCriteriaSource)[keyof typeof TaskEvaluationConfigFormalCriteriaSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskEvaluationConfigFormalCriteriaSource = {
  default: 'default',
  task_params: 'task_params',
  rubric: 'rubric',
} as const;
